import React, { useState, useEffect, Fragment } from "react"
import MembersCard from "../../../../components/MembersCard"
import InfiniteScroll from "react-infinite-scroll-component"

const Members = ({ users, searchFilter, sort, filter }) => {
  const [filteredUsers, setFilteredUsers] = useState([])
  const [membersPerPage, setMembersPerPage] = useState([])

  const searchUsers = () => {
    const searchRegExp = new RegExp(searchFilter, "i")
    let matches = users.filter(user => {
      const name = user.first_name + " " + user.last_name
      return name.search(searchRegExp) > -1
    })
    if (sort) {
      if (sort.dir === "ASC") {
        matches = matches.sort((a, b) =>
          ("" + sort.getVal(a)).localeCompare(sort.getVal(b))
        )
      } else {
        matches = matches.sort((a, b) =>
          ("" + sort.getVal(b)).localeCompare(sort.getVal(a))
        )
      }
    }

    if (filter) {
      matches = matches.filter(filter.filter)
    }

    setFilteredUsers(matches)
  }

  useEffect(() => {
    searchUsers()
  }, [searchFilter, users, sort, filter])
  let displayedUsers =
    filteredUsers.length || searchFilter.length > 0 || filter
      ? filteredUsers
      : users

  const fetchMoreData = () => {
    // setTimeout(() => {
    setMembersPerPage(displayedUsers.slice(0, membersPerPage.length + 12))
    // }, 1000)
  }

  useEffect(() => {
    setMembersPerPage(displayedUsers.slice(0, 12))
  }, [displayedUsers])

  return membersPerPage.map((user, i) => {
    const newUser = Object.assign({}, user)
    if (newUser.profile_image) {
      try {
        newUser.profile_image = JSON.parse(newUser.profile_image).public_id
      } catch (error) {
        newUser.profile_image = null
      }
    }
    newUser.can_post = Boolean(newUser.can_post)
    newUser.name = `${newUser.first_name} ${newUser.last_name}`
    return (
      <Fragment key={i}>
        <InfiniteScroll
          dataLength={membersPerPage.length}
          next={fetchMoreData}
          hasMore="true"
          // loader={<h4>Loading...</h4>}
          endMessage={
            <p style={{ textAlign: "center" }}>
              <b>Yay! You have seen it all</b>
            </p>
          }
        >
          <MembersCard key={i} user={newUser} />
        </InfiniteScroll>
      </Fragment>
    )
  })
}

export default Members



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Members/members.js